/* eslint-disable react/react-in-jsx-scope */
import * as pdfjsLib from "pdfjs-dist";
import { useEffect, useState } from "react";

import IconImg from "@/assets/icones/images.svg?react";
import { Button } from "@/components/ui/button";
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import pdfWorker from "@/pdf-worker";
import { Download, Eye, MoreVertical } from "lucide-react";
pdfjsLib.GlobalWorkerOptions.workerPort = new pdfWorker();

type ImageThumbnailProps = {
  url: string;
  treeFinancer: any;
  pj: any;
  noMore?: boolean;
};

export const ImageThumbnail = ({
  url,
  treeFinancer,
  pj,
  noMore = false,
}: ImageThumbnailProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [isThumbLoading, setIsThumbLoading] = useState(true);

  useEffect(() => {
    setIsThumbLoading(true);
  }, [url]);

  return (
    <div className={` ${!noMore && "bg-muted p-3"} rounded-md relative`}>
      {!noMore && (
        <div className="flex justify-between items-center relative z-10 mb-2">
          <Tooltip>
            <TooltipTrigger asChild>
              <div
                className="flex items-center gap-3 "
                style={{ width: "calc(100% - 45px)" }}
              >
                <IconImg width={18} height={18} />
                <h3 className="truncate flex-1">{pj.name}</h3>
              </div>
            </TooltipTrigger>
            <TooltipContent className="flex flex-col gap-2">
              <div>
                Porteur de projet :{" "}
                <strong>
                  {treeFinancer?.find((t) => t.id === pj.pp)?.name}
                </strong>
              </div>
              <div>
                Programme :{" "}
                <strong>
                  {
                    treeFinancer
                      ?.find((t) => t.id === pj.pp)
                      ?.programs.find((p) => p.id === pj.program)?.name
                  }
                </strong>
              </div>
              <div>
                Projet :{" "}
                <strong>
                  {
                    treeFinancer
                      ?.find((t) => t.id === pj.pp)
                      ?.programs.find((p) => p.id === pj.program)
                      ?.projects.find((p) => p.id === pj.project)?.name
                  }
                </strong>
              </div>
            </TooltipContent>
          </Tooltip>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="ghost"
                className="px-2 outline-none border-0 border-none ring-0 hover:bg-black/5 w-auto h-auto"
              >
                <MoreVertical className="text-foreground" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="flex flex-col gap-2" align="end">
              <DropdownMenuItem asChild>
                <button
                  onClick={() => setModalOpen(true)}
                  className="flex gap-2 items-center cursor-pointer text-foreground"
                >
                  <Eye width={22} height={22} /> Ouvrir
                </button>
              </DropdownMenuItem>
              <DropdownMenuItem asChild>
                <a
                  href={url}
                  download
                  className="flex gap-2 items-center cursor-pointer text-foreground"
                >
                  <Download width={22} height={22} /> Télécharger
                </a>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      )}
      <Dialog open={modalOpen} onOpenChange={setModalOpen}>
        <DialogTrigger asChild>
          <div className="relative h-[17rem] overflow-hidden rounded-md bg-white flex items-center justify-center cursor-pointer">
            {isThumbLoading && (
              <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/90">
                <LoadingSpinner className="text-primary" size={18} />
              </div>
            )}
            <img
              src={url}
              alt={pj.name}
              className="object-cover w-full h-full"
              onLoad={() => setIsThumbLoading(false)}
              onError={() => setIsThumbLoading(false)}
            />
          </div>
        </DialogTrigger>

        <DialogContent className="sm:max-w-4xl sm:w-full h-[80vh] flex flex-col">
          <img
            src={url}
            alt={pj.name}
            className="w-auto h-[90%] object-contain"
          />

          <DialogClose asChild>
            <Button variant="outline" className="mt-4 w-max m-auto">
              Fermer
            </Button>
          </DialogClose>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ImageThumbnail;
